<template>
  <div class="fixed w-screen h-screen top-0 left-0" style="z-index: 2000">
    <div
      class="w-full h-full flex justify-content-center align-items-center bg-blur"
    >
      <ProgressSpinner style="width: 50px; height: 50px" />
    </div>
  </div>
</template>

<script setup>
import ProgressSpinner from "primevue/progressspinner";
</script>

<style scoped>
.bg-blur {
  background: rgba(var(--mask-bg), 0.5) !important;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
</style>
